import { Reducer } from 'redux';
import {
  PROJECTS_SET_PROJECTS,
  PROJECTS_SET_SELECTED_PROJECT,
  IStoreProjects,
  IStoreProjectsSetProjectsAction,
  IStoreProjectsSetSelectedProjectAction,
} from '../projects';

export type IProjectsActions = IStoreProjectsSetProjectsAction | IStoreProjectsSetSelectedProjectAction;

const initialState: IStoreProjects = {
  filters: {
    groupId: null,
    projectId: null,
    showArchived: false,
  },
  projects: [],
  selectedProject: null,
};

const projectsReducers: Reducer<IStoreProjects, IProjectsActions> = (state = initialState, action) => {
  switch (action.type) {
    case PROJECTS_SET_PROJECTS:
      return {
        ...state,
        projects: action.payload.projects,
      };
    case PROJECTS_SET_SELECTED_PROJECT:
      return {
        ...state,
        selectedProject: action.payload.selectedProject,
      };
    default:
      return state;
  }
};

export default projectsReducers;
